const data = [
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-79.534, 8.971], [-77, 7.5], [-76.5, 3], [-80.822, -1.032]]
		},
		name: 'Intercontinental 1',
		cities: ['Balboa', 'Manta']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-79.534, 8.971], [-77, 8.5], [-75.5, 9.5]]
		},
		name: 'Intercontinental 1',
		cities: ['Balboa', 'Cartagena']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-79.534, 8.971], [-76, 19], [-80.194, 25.774]]
		},
		name: 'Intercontinental 1',
		cities: ['Balboa', 'Miami']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-79.534, 8.971], [-75, 20], [-81.4, 30.332]]
		},
		name: 'Intercontinental 1',
		cities: ['Balboa', 'Jacksonville']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.5, 8.65], [-82, 15], [-80.194, 25.774]]
		},
		name: 'Intercontinental 1',
		cities: ['Panama', 'Miami']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.5, 8.65], [-83, 15], [-81.4, 30.332]]
		},
		name: 'Intercontinental 1',
		cities: ['Panama', 'Jacksonville']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-76.878, -12.277], [-76, -20], [-71.62, -33.046]]
		},
		name: 'Intercontinental 1',
		cities: ['Lurin', 'valparaiso']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-76.878, -12.277], [-83, -25.7], [-80, -33.438], [-70.65, -33.438]]
		},
		name: 'Intercontinental 1',
		cities: ['Lurin', 'Santiago de Chile']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-71.62, -33.046], [-72, -33.3], [-70.65, -33.438]]
		}, 
		name: 'Intercontinental 1',
		cities: ['valparaiso', 'Santiago']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-79.534, 8.971], [-79.753, 9.441], [-84.077, 9.913]]
		},
		name: 'Intercontinental 1',
		cities: ['Balboa', 'Maria Chiquita', 'San Jose']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-90.513, 14.642], [-88, 14], [-86.274, 12.146]]
		},
		name: 'Intercontinental 1',
		cities: ['Guatemala', 'Managua']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-90.513, 14.642], [-88.435, 15.836], [-80.194, 25.774]]
		},
		name: 'Intercontinental 1',
		cities: ['Guatemala', 'Pto Barrios', 'Miami']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-86.274, 12.146], [-84.077, 9.913]]
		},
		name: 'Intercontinental 1',
		cities: ['Managua', 'San Jose']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-70.65, -33.438], [-65, -36], [-58.437, -34.608]]
		},
		name: 'Intercontinental 1',
		cities: ['Santiago', 'Buenos Aires']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-56.706, -36.488], [-47, -33.5], [-46.291, -23.96]]
		},
		name: 'Intercontinental 1',
		cities: ['Las Toninas', 'Santos']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-56.706, -36.488], [-58.7, -36], [-58.437, -34.608]]
		},
		cities: ['Las Toninas', 'Buenos Aires']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-58.437, -34.608], [-48.3, -32.5], [-46.291, -23.961]]
		},
		cities: ['Buenos Aires', 'Santos']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-58.437, -34.608], [-32, -25], [-32, 20], [-75.977, 36.853]]
		},
		cities: ['Buenos Aires', 'Virginia Beach']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-46.291, -23.96], [-44, -23], [-43.209, -22.911]]
		},
		cities: ['santos', 'rio de janeiro']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-46.291, -23.96], [-31, -16.5], [-33.5, 20.5], [-75.977, 36.853]]
		},
		cities: ['Santos', 'Virginia Beach']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-46.291, -23.96], [-43, -16], [-38.502, -12.978]]
		},
		cities: ['Santos', 'Salvador Bahía']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-46.291, -23.96], [-47.6, -22.75], [-49.023, -21.955]]
		},
		cities: ['Santos', 'Sao Paulo']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-46.291, -23.96], [-48.2, -23], [-49.023, -21.955]]
		},
		cities: ['Santos', 'Sao Paulo']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-43.209, -22.911], [-41, -11], [-38.522, -3.73]]
		},
		cities: ['rio de janeiro', 'fortaleza']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-43.209, -22.911], [-31.5, -15], [-34.5, 20], [-75.977, 36.853]]
		},
		cities: ['Santos', 'Virginia Beach']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-38.502, -12.978], [-31.5, -5], [-37, 21.5], [-75.977, 36.853]]
		},
		cities: ['Salvador de Bahia', 'Virginia Beach']
	},
	///  florida - south america
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-46.343, 15.974], [-38.502, -12.978]]
		},
		cities: ['Miami', 'Salvador de Bahía']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-43.706, 18.159], [-43.209, -22.911]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-50.035, 15.128], [-38.521, -3.73]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-51.616, 8.073], [-46.291, -23.961]]
		},
		cities: ['Miami', 'Santos']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-52.847, -0.689], [-58.437, -34.608]]
		},
		cities: ['Miami', 'Buenos Aires']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-71.436, 19.882], [-74.81, 11.012]]
		},
		properties: {
			name: 'barranquilla'
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-77.586, 24.44], [-66.413, 18.221]]
		},
		cities: ['Miami', 'San Juan']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-66.413, 18.221], [-71, 15.5], [-74.8, 11.012]]
		},
		cities: ['San Juan', 'Barranquilla']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-72.28, 19.696], [-75.509, 10.4]],
			cities: ['Miami', 'Cartagena']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-84.138, 12.825], [-80.822, -1.032]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-81.045, -4.103], [-80.25, -3], [-80.927, -2.256]]
		},
		cities: ['Mancora', 'Salinas']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-81.045, -4.103], [-76.75, -7], [-77.042, -11.046]]
		},
		cities: ['Mancora', 'Lima']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-81.045, -4.103], [-81.5, -9.55], [-76.878, -12.277]]
		},
		cities: ['Mancora', 'Lurin']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.927, -2.256], [-80.822, -1.032]]
		},
		cities: ['Salinas', 'Manta']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.083, 26.359], [-85.207, 12.181], [-81.045, -4.103]]
		},
		cities: ['Boca Raton', 'JacksonVille']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.083, 26.359], [-70.00, 26.0], [-66.413, 18.221]]
		},
		cities: ['Boca Raton', 'Puerto Rico']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-80.194, 26], [-80.083, 26.359]]
		},
		cities: ['Miami', 'Boca Raton']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.083, 26.359], [-83.045, 12], [-81.045, -4.103]]
		},
		cities: ['Boca Raton', 'JacksonVille']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-94, 14], [-93, -7], [-76.878, -12.277]]
		},
		cities: ['Miami', 'Lurin']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-94.5, 14], [-93, -9], [-70.321, -18.479]]
		},
		cities: ['Miami', 'Arica']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-95, 15], [-94, -10], [-71.62, -33.046]]
		},
		cities: ['Miami', 'Valparaiso']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-86.564, 19.113], [-84.077, 9.913]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.194, 25.774], [-86.984, 22], [-90.513, 14.642]],
			cities: ['Guatemala', 'Miami']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-90.513, 14.642], [-90, 24], [-81.4, 30.332]],
			cities: ['Guatemala', 'Jacksonville']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-90.513, 14.642], [-94, 10], [-92.5, -6.5],  [-76.878, -12.277]],
			cities: ['Guatemala', 'Lurín']
		}
	},
	////  South america
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-66.413, 18.221], [-48, 10], [-38.522, -3.73]]
		},
		cities: ['San Juan de Puerto Rico', 'Fortaleza']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-66.413, 18.221], [-45.622, 3.408], [-46.291, -23.961]]
		},
		cities: ['San Juan de Puerto Rico', 'Santos']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-90.513, 14.642], [-85.778, 14.162], [-84.077, 9.913]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-77.042, -11.046], [-77.3, -11.6], [-76.878, -12.277]]
		},
		cities: ['Lima', 'Lurin']
	},
	{
		geometry: {
			type: 'LineString2',
			coordinates: [[-77.042, -11.046], [-76.7, -11.65], [-76.878, -12.277]]
		},
		cities: ['Lima', 'Lurin']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-80.927, -2.256], [-82.5, -9.55], [-76.878, -12.277]]
		},
		cities: ['Salinas', 'Lurin']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-70.32, -18.48], [-73, -25.2], [-71.62, -33.046]]
		},
		cities: ['Arica', 'Valparaiso']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-71.62, -33.05], [-64.8, -30.74], [-58.44, -34.6]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-71.62, -33.046], [-70.24, -32.75], [-68.846, -32.889]]
		},
		cities: ['Valparaiso', 'Mendoza']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-68.846, -32.889], [-63.942, -32.276], [-58.437, -34.608]]
		},
		cities: ['Mendoza', 'Buenos Aires']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-43.209, -22.911], [-42, -18.84], [-38.502, -12.978]]
		},
		cities: ['Rio de Janeiro', 'Salvador']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-38.522, -3.73], [-36.5, -8.438], [-38.502, -12.978]]
		},
		cities: ['Fortaleza', 'Salvador de Bahia']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-38.522, -3.73], [-35, -9], [-38, -21], [-46.291, -23.961]]
		},
		cities: ['Fortaleza', 'Santos']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-38.522, -3.73], [-34, 0.5], [-38, 21], [-75.977, 36.853]]
		},
		cities: ['Fortaleza', 'Virginia Beach']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-76.878, -12.277], [-57, -14.166], [-46.291, -23.961]]
		},
		properties: {
			name: 'Lurin - Santos',
			cities: ['Lurin', 'Santos']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-76.878, -12.277], [-57, -12.424], [-43.209, -22.911]]
		},
		cities: ['Lurin', 'Rio de Janerio']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-74.81, 11.012], [-54.13, 9], [-38.522, -3.73]],
			cities: ['Barranquilla', 'Fortaleza']
		}
	},

	// *****************************************
	//
	// USA             *************************
	//
	// *****************************************

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-112.071, 33.451], [-105, 36], [-96.8, 32.776]]
		},
		cities: ['Phoenix', 'Dallas']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-112.071, 33.451], [-107, 28], [-99.509, 27.506]]
		},
		cities: ['Phoenix', 'Laredo']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-112.071, 33.451], [-100, 30], [-80.083, 26.359]]
		},
		cities: ['Phoenix', 'Boca Raton']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-96.797, 32.776], [-88.003, 39.639], [-77.487, 39.044]],
			cities: ['Dallas', 'Ashburn']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-77.487, 39.044], [-76.12, 32.680], [-80.083, 26.359]]
		},
		cities: ['Ashburn', 'Boca Raton']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-77.487, 39.044], [-74.12, 33.680], [-80.194, 25.774]]
		},
		cities: ['Ashburn', 'Miami']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-77.487, 39.044], [-81.00, 34.50], [-81.4, 30.332]]
		},
		cities: ['Ashburn', 'Jacksonville']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-99.509, 27.506], [-90.5, 26.028], [-80.194, 25.774]]
		},
		cities: ['Laredo', 'Miami']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-96.797, 32.776], [-95.5, 29.028], [-98.23, 26.204]],
			cities: ['Dallas', 'McAllen']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-96.797, 32.776], [-99.4, 30.855], [-99.509, 27.506]],
			cities: ['Dallas', 'Laredo']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-96.797, 32.776], [-89, 35], [-81.4, 30.332]],
			cities: ['Dallas', 'Jacksonville']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-96.797, 32.776], [-89, 33.5], [-80.083, 26.359]],
			cities: ['Dallas', 'Boca Ratón']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-98.23, 26.2], [-99, 26.5], [-99.509, 27.506]],
			cities: ['McAllen', 'Laredo']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-98.23, 26.2], [-90, 25], [-80.194, 25.774]],
			cities: ['McAllen', 'Miami']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-77.487, 39.044], [-77.501, 37.51], [-75.977, 36.853]]
		},
		cities: ['Ashburn', 'Virginia Beach']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-75.977, 36.853], [-79.50, 35.50], [-81.4, 30.332]]
		},
		cities: ['Virginia Beach', 'Jacksonville']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-75.977, 36.853], [-79.50, 33.50], [-80.083, 26.359]]
		},
		cities: ['Virginia Beach', 'Boca Raton']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-81.4, 30.332], [-81, 28], [-80.083, 26.359]]
		},
		cities: ['Jacksonville', 'Boca Raton']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-81.4, 30.332], [-70, 28.5], [-66.413, 18.221]]
		},
		cities: ['Jacksonville', 'Puerto Rico']
	},

	// *****************************************
	// EUROPE
	// *****************************************

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-3.704, 40.417], [-8.64, 46.98], [-0.13, 51.507]],
			cities: ['Madrid', 'Barcelona']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-3.704, 40.417], [-1, 41], [2.2, 41.7]]
		}
	},
	// París - Barcelona
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.3512, 48.857], [-1.695, 45.337], [2.2, 41.7]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.352, 48.857], [-4.05, 46.32], [-3.704, 40.417]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.3512, 48.857], [-0.707, 49.431], [-0.128, 51.507]]
		}
	},
	// London - Barcelona
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-0.1278, 51.507], [-3.453, 46.01], [2.2, 41.7]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.352, 48.857], [0.546, 45.192], [5.37, 43.296]]
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[8.682, 50.111], [4.51, 48.03], [5.37, 43.296]],
			cities: ['Frankfurt', 'Marseille']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[8.682, 50.11], [4.9, 53.0], [-0.13, 51.507]],
			cities: ['Frankfurt', 'London']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[8.682, 50.111], [4.75, 50.3], [2.352, 48.857]],
			cities: ['Frankfurt', 'Paris']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[4.898, 52.375], [1.265, 51.479], [2.352, 48.857]],
			cities: ['Amsterdam', 'Paris']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[4.898, 52.375], [2.363, 52.500], [-0.128, 51.507]],
			cities: ['Amsterdam', 'London']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-75.50, 9.5], [-74, 7], [-74.076, 4.598]],
			cities: ['Cartagena', 'Bogota']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-75.50, 9.5], [-74.9, 10.8], [-74.809, 11.012]],
			cities: ['Cartagena', 'Barranquilla']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-75.509, 10.4], [-76, 3], [-80.822, -1.032]],
			cities: ['Cartagena', 'Manta']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-74.809, 11.012], [-73.5, 7], [-74.076, 4.598]],
			cities: ['Barranquilla', 'Bogota']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[6.776, 51.225], [3.75, 50.75], [2.352, 48.857]],
			cities: ['Düsseldorf', 'Paris']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[6.776, 51.225], [8.3, 51], [8.682, 50.111]],
			cities: ['Düsseldorf', 'Frankfurt']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[6.776, 51.225], [3.924, 53.1], [-0.128, 51.5]],
			cities: ['Düsseldorf', 'London']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-2.935, 43.261], [-3.4, 41.7], [-3.704, 40.417]]
		},
		cities: ['Bilbao', 'Madrid']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-2.935, 43.261], [0, 47], [2.352, 48.857]]
		},
		cities: ['Bilbao', 'Paris']
	},

	// *****************************************
	// EUROPE - USA       
	// *****************************************
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.352, 48.857], [-36, 60], [-75.977, 36.853]]
		},
		cities: ['Paris', 'Virginia Beach']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.352, 48.857], [-36, 55], [-77.487, 39.044]]
		},
		cities: ['Paris', 'Ashburn']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-0.13, 51.507], [-36, 63], [-77.487, 39.044]],
			cities: ['London', 'Ashburn']
		}
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-3.704, 40.417],  [-36, 52], [-75.977, 36.853]],
			cities: ['Madrid', 'Virginia Beach']
		}
	},


	{
		geometry: {
			type: "LineString",
			coordinates: [[-2.935, 43.261], [2.2, 41.7]]
		},
		name: "Europa 3",
		cities: ["Derio", "Barcelona"]
	}

];
export default data;
